import { render, staticRenderFns } from "./ProfileConfirmationRow.vue?vue&type=template&id=2b2748ae&scoped=true"
import script from "./ProfileConfirmationRow.vue?vue&type=script&lang=ts"
export * from "./ProfileConfirmationRow.vue?vue&type=script&lang=ts"
import style0 from "./ProfileConfirmationRow.vue?vue&type=style&index=0&id=2b2748ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2748ae",
  null
  
)

export default component.exports